import React from 'react';
import { useNavigate } from 'react-router-dom';
import { floatingActionButtonStyles } from './FloatingActionButton.styles';

const FloatingActionButton = () => {
  const navigate = useNavigate();
  
  return (
    <button onClick={() => navigate('/compose')} style={floatingActionButtonStyles.button}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
          d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" 
          {...floatingActionButtonStyles.icon}
        />
      </svg>
    </button>
  );
};

export default FloatingActionButton; 